import styled from 'styled-components';

export const ContainerButton = styled.div`
  margin: 5px;
`;
